import React, { FC } from 'react';
import {
    GET_JOB_FILTERS_LIST,
    GET_ALL_REGIONS,
    GET_ALL_CREWS,
    GET_ALL_EPCOMPANIES,
    GET_ALL_CUSTOMERS,
    GET_ALL_STATES,
} from '../../graphql/client/queries';
import {
    GetJobFiltersList,
    GetJobFiltersList_getJobFiltersList_statuses as StatusType,
    GetAllCrews_getAllCrews as CrewType,
    GetAllCustomers,
    GetAllCustomers_getAllCustomers as CustomerType,
    GetAllEpCompanies,
    GetAllEpCompanies_getAllEpCompanies as EPCompanyType,
    GetAllRegions,
    GetAllRegions_getAllRegions as RegionType,
    GetAllStates,
    GetAllStates_getAllStates as StateType,
    GetFullJobProfile,
} from '../../types/schemaTypes';
import { Query } from '../_common';
import { Error, Loading } from '../_common';
import './EditJob.scss';
import GET_JOB_PROFILE from '../../graphql/client/queries/getJobProfile';
import { useQuery } from '@apollo/client/react';
import EditJobForm from './EditJobForm';
import { useParams } from 'react-router-dom';

interface Option {
    id: number | string;
    name: string | number;
}

interface Suggestion {
    id: string | number;
    name: string;
}

const EditJob: FC = ({ match }: any): React.ReactElement => {
    const { jobId } = useParams()
    const jobIdVal: any = jobId

    const variables = {
        jobId: parseInt(jobIdVal)
    };

    const { data: jobProfileData, loading: jobProfileLoading } = useQuery<GetFullJobProfile>(GET_JOB_PROFILE, {
        variables: {
            jobId: variables.jobId,
        },
    });
    const { data: jobFiltersData, loading: jobFiltersLoading } = useQuery<GetJobFiltersList>(GET_JOB_FILTERS_LIST);
    const { data: regionsData, loading: regionsLoading } = useQuery<GetAllRegions>(GET_ALL_REGIONS);
    const { data: epCompaniesData, loading: epCompaniesLoading } = useQuery<GetAllEpCompanies>(GET_ALL_EPCOMPANIES);
    const { data: customersData, loading: customersLoading } = useQuery<GetAllCustomers>(GET_ALL_CUSTOMERS);
    const { data: statesData, loading: statesLoading } = useQuery<GetAllStates>(GET_ALL_STATES);

    const regions: Option[] = [];
    const customers: Suggestion[] = [];
    const epCompanies: Suggestion[] = [];
    const states: Suggestion[] = [];
    const statuses: Option[] = [];
    const crews: Suggestion[] = [];
    let regionsWithDistricts: RegionType[] = [];

    if (jobFiltersData && jobFiltersData.getJobFiltersList && jobFiltersData.getJobFiltersList.statuses) {
        jobFiltersData.getJobFiltersList.statuses.forEach((element: StatusType) => {
            statuses.push({
                id: element.id,
                name: element.name,
            });
        });
    }

    if (regionsData?.getAllRegions) {
        regionsWithDistricts = (regionsData.getAllRegions ?? []).filter((r): r is RegionType => r != null);
        (regionsData.getAllRegions as (RegionType | null)[]).forEach((element: RegionType | null): void => {
            if (element != null && element.regionName != null) {
                regions.push({
                    id: element.id,
                    name: element.regionName,
                });
            }
        });
    }

    if (epCompaniesData?.getAllEpCompanies) {
        (epCompaniesData.getAllEpCompanies as (EPCompanyType | null)[]).forEach((element: EPCompanyType | null): void => {
            if (element != null && element.companyName != null) {
                epCompanies.push({
                    id: element.id,
                    name: element.companyName,
                });
            }
        });
    }

    if (customersData?.getAllCustomers) {
        (customersData.getAllCustomers as (CustomerType | null)[]).forEach((element: CustomerType | null): void => {
            if (element != null && element.customerName != null && element.id != null) {
                customers.push({
                    id: element.id,
                    name: element.customerName,
                });
            }
        });
    }

    if (statesData?.getAllStates) {
        (statesData.getAllStates as (StateType | null)[]).forEach((element: StateType | null): void => {
            if (element != null && element.stateName != null && element.id != null) {
                states.push({
                    id: element.id,
                    name: element.stateName,
                });
            }
        });
    }

    if (jobProfileData?.getJobProfile) {
        return (
            <Query
                query={GET_ALL_CREWS}
                variables={{
                    customerId: jobProfileData.getJobProfile.customerDetails?.customerId ?? 0,
                }}
            >
                {({ loading: crewsLoading, error: crewsError, data: crewsData }: any): React.ReactElement | null => {
                    if (
                        jobFiltersLoading ||
                        regionsLoading ||
                        epCompaniesLoading ||
                        customersLoading ||
                        statesLoading ||
                        crewsLoading ||
                        jobProfileLoading
                    ) {
                        return <Loading />;
                    }

                    if (crewsError) {
                        return <Error error={crewsError} />;
                    }

                    if (crewsData && crewsData.getAllCrews) {
                        crewsData.getAllCrews.forEach((element: CrewType | null) => {
                            if (element && element.crewNumber !== null) {
                                crews.push({
                                    id: element.id,
                                    name: element.crewNumber,
                                });
                            }
                        });

                        return (
                            <EditJobForm
                                jobProfileData={jobProfileData.getJobProfile}
                                regionsWithDistricts={regionsWithDistricts}
                                regions={regions}
                                customers={customers}
                                epCompanies={epCompanies}
                                states={states}
                                statuses={statuses}
                                crews={crews}
                                jobId={variables.jobId}
                            />
                        );
                    } else {
                        return <div></div>;
                    }
                }}
            </Query>
        );
    } else {
        return <div></div>;
    }
};

export default EditJob;

